import { render } from "./answerFreq.vue?vue&type=template&id=76954abe&scoped=true"
import script from "./answerFreq.vue?vue&type=script&lang=js"
export * from "./answerFreq.vue?vue&type=script&lang=js"

import "./answerFreq.vue?vue&type=style&index=0&id=76954abe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76954abe"]])

export default __exports__